import React, { useEffect } from 'react';

const Chat = () => {
  useEffect(() => {
    // Add the Tawk.to script to the document head
    const script = document.createElement('script');
    script.src = 'https://embed.tawk.to/YOUR_PROPERTY_ID/DEFAULT'; // Replace with your Tawk.to property ID
    script.async = true;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.head.appendChild(script);

    // Clean up the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div>
      {/* Your chat component can have additional UI elements if needed */}
      <p>Chat with us live!</p>
    </div>
  );
};

export default Chat;
